import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/myNiceScroll'
import {resizeScroll} from '../../assets/scripts/myNiceScroll'

// banner效果
!(function(){
  let randnum = createRand(20,80)
  $('.field-banner .bg-img').css('left', randnum + '%')
  if($('.field-case-list ul li').length <= 6){
    $('.field-case').addClass('show-all')
  }
})()

function createRand(x,y){
  //x是小数，y是大数
  let randnum = parseInt(Math.random()*(y-x+1)+x);
  return randnum;
}

var swiper = new Swiper(".honor-swiper .mySwiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: ".field-honor .swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 3000,
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 35,
    },
    1280: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 60,
    }
  },
});


if($('.common-list').length > 0){
  // 查看更多
  if($(window).width() > 992){
    var cmListinitshowliNum = 3
    var cmListshowstep = 3
  }else{
    var cmListinitshowliNum = 2
    var cmListshowstep = 2
  }
  var cmListclickNum = 0
  var cmListtotalli = $('.common-list ul li').length

  if (cmListtotalli <= 3 && $(window).width() > 992 || cmListtotalli <= 2 && $(window).width() <= 992) {
      $('.common-list .common-more-btn').hide()
  }

  $('.common-list .common-more-btn').on('click', function () {
    cmListclickNum += 1
      if (cmListinitshowliNum + cmListshowstep * cmListclickNum < cmListtotalli) {
          for (let i = 0; i < cmListshowstep; i++) {
              $('.common-list ul li').eq(cmListinitshowliNum + (cmListclickNum - 1) * cmListshowstep + i).show()
          }
      } else {
          for (let i = 0; i < cmListtotalli - cmListclickNum * cmListshowstep; i++) {
              $('.common-list ul li').eq(cmListinitshowliNum + (cmListclickNum - 1) * cmListshowstep + i).show()
          }
          $('.common-list .common-more-btn').hide()
      }
      resizeScroll()
  })
}

//显示全部
$('.field-case .more-cont .common-more-btn').on('click',function(){
  $('.field-case').addClass('show-all')
  resizeScroll()
})